import { Fragment } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';

const Organisation = ({ state, updateState, nextStep, previousStep }) => (
  <Formik
    initialValues={{
      primary_email: state?.data?.contact_information?.primary_email || '',
      finance_email: state?.data?.contact_information?.finance_email || '',
      tech_email: state?.data?.contact_information?.tech_email || '',
      contact_number: state?.data?.contact_information?.contact_number || '',
    }}
    validationSchema={Yup.object().shape({
      primary_email: Yup
        .string()
        .email('Must be a valid email address')
        .required('Primary email address is required'),
      finance_email: Yup
        .string()
        .email('Must be a valid email address')
        .required('Finance email address is required'),
      tech_email: Yup
        .string()
        .email('Must be a valid email address')
        .required('Technology email address is required'),
      contact_number: Yup
        .string('Must be a valid phone number')
        .required('Contact number is required'),
    })}
    onSubmit={async (values, {
      setSubmitting
    }) => {
      setSubmitting(true);
      updateState('contact_information', values);
      nextStep();
    }}
  >
    {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
        setFieldValue,
      }) => (
      <Fragment>
        <form action="#" method="POST" onSubmit={handleSubmit}>

        <h1 className="text-2xl font-semibold mb-6">Contact Information</h1>

          <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

            <div className="sm:col-span-2 mb-2">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold" htmlFor="grid-state">
                Primary email address *
              </label>
              <p className="text-xs text-felloh">This is your primary email address for account setup, etc...</p>
              <div className="mt-2.5">
                <input type="text"
                       name="primary_email"
                       id="primary_email"
                       value={values.primary_email}
                       onBlur={handleBlur}
                       onChange={handleChange}
                       autoComplete="organization"
                       placeholder={'e.g. help@your-agency.com'}
                       className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.primary_email && errors.primary_email ? ' border-red-500' : ''}`}
                />
                {touched.primary_email && errors.primary_email && <div className="field-error">{errors.primary_email}</div>}
              </div>
            </div>

            <div className="sm:col-span-2 mb-2">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold" htmlFor="grid-state">
                Finance email address *
              </label>
              <p className="text-xs text-felloh">This is your contact email address for financial queries</p>
              <div className="mt-2.5">
                <input type="text"
                       name="finance_email"
                       id="finance_email"
                       value={values.finance_email}
                       onBlur={handleBlur}
                       onChange={handleChange}
                       autoComplete="organization"
                       placeholder={'e.g. finance@your-agency.com'}
                       className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.finance_email && errors.finance_email ? ' border-red-500' : ''}`}
                />
                {touched.finance_email && errors.finance_email && <div className="field-error">{errors.finance_email}</div>}
              </div>
            </div>

            <div className="sm:col-span-2 mb-2">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold" htmlFor="grid-state">
                Technical email address *
              </label>
              <p className="text-xs text-felloh">This is your contact email address for technical issues, integration problems, etc..</p>
              <div className="mt-2.5">
                <input type="text"
                       name="tech_email"
                       id="tech_email"
                       value={values.tech_email}
                       onBlur={handleBlur}
                       onChange={handleChange}
                       autoComplete="organization"
                       placeholder={'e.g. technology@your-agency.com'}
                       className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.tech_email && errors.tech_email ? ' border-red-500' : ''}`}
                />
                {touched.tech_email && errors.tech_email && <div className="field-error">{errors.tech_email}</div>}
              </div>
            </div>

            <div className="sm:col-span-2 mb-2">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                Main business phone number *
              </label>
              <div className="mt-2.5">
                <input type="text"
                       name="contact_number"
                       id="contact_number"
                       value={values.contact_number}
                       onBlur={handleBlur}
                       onChange={handleChange}
                       autoComplete="organization"
                       placeholder={'e.g. 020 8254 3062'}
                       className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.contact_number && errors.contact_number ? ' border-red-500' : ''}`}
                />
                {touched.contact_number && errors.contact_number && <div className="field-error">{errors.contact_number}</div>}
              </div>
            </div>



          </div>

          <div className="mt-12">
            <button type="submit"
                    className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
              Next
            </button>
          </div>

          <div className="mt-4">
            <button type="button"
                    onClick={previousStep}
                    className="block w-full rounded-md bg-slate-300 px-3.5 py-2.5 text-center text-md font-semibold text-black shadow-sm hover:text-white hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
              Previous
            </button>
          </div>
        </form>
      </Fragment>
    )}
  </Formik>
);

export default Organisation;
